<m-debug-events-panel
  *ngIf="showEvents && !secondFileNodeId"
  class="flex w-full"
></m-debug-events-panel>

<m-sessions
  *ngIf="
    builderRight === builderRightSessions && !secondFileNodeId && !showEvents
  "
  class="flex w-full"
></m-sessions>

<m-schemas
  *ngIf="
    builderRight === builderRightSchema && !secondFileNodeId && !showEvents
  "
  class="flex w-full"
></m-schemas>

<m-validation-status
  *ngIf="
    builderRight === builderRightValidation && !secondFileNodeId && !showEvents
  "
  class="flex w-full"
></m-validation-status>

<m-second-file *ngIf="!!secondFileNodeId" class="flex w-full"></m-second-file>

<div *ngIf="secondFileNodeId$ | async"></div>
<div *ngIf="builderRight$ | async"></div>
<div *ngIf="showEvents$ | async"></div>
